<template>
  <div style="height: 65vh;margin: 0 4%;">
    <div class="text-blue padding-top-20">
      整体联动图
    </div>
    <div style="width: 100%;height: 30vh;margin-top: 10px;"
         class="border-dash">
      <div class="containersView" ref="containers">
        <div class="canvas" ref="canvas"/>
        <div class="toolbar">
              <span class="el-icon-zoom-in pointer"
                    @touchstart="handleZoom(0.2)"
                    @click="handleZoom(0.2)"
                    style="color: #000;font-size: 1.5rem"></span>
          <span class="el-icon-zoom-out pointer margin-left-5"
                @touchstart="handleZoom(-0.2)"
                @click="handleZoom(-0.2)"
                style="color: #000;font-size: 1.5rem"></span>
          <span class="pointer margin-left-5"
                @touchstart="fullScreen()"
                @click="fullScreen()"
                style="color: #000;font-size: 1.5rem">
            <i class="el-icon-full-screen" v-if="!isFullScreen"></i>
            <img src="../../../../assets/images/icon/退出全屏.png"
                 style="margin-top: -7px" v-else>
          </span>
        </div>
      </div>
    </div>
    <div class="text-blue padding-top-20">
      联动列表
    </div>
    <div style="overflow-y: auto;height:30vh">
      <el-table
        :data="tableData"
        :height="'25vh'"
        class="table"
        style="width: 100%;margin-top: 10px;">
        <el-table-column
          align="center"
          label="触发时间"
          prop="createTime">
        </el-table-column>
        <el-table-column
          align="center"
          label="设备名称"
          prop="deviceName">
        </el-table-column>
        <el-table-column
          align="center"
          label="联动结果"
          prop="success">
          <template slot-scope="scope">
            {{ scope.row.success ? '成功' : '失败' }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="备注说明"
          prop="note">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import BpmnViewer from "bpmn-js/lib/Viewer"; //只需预览引入viewer即可
// import MoveModule from "diagram-js/lib/features/move";
import ModelingModule from 'bpmn-js/lib/features/modeling';
import MoveCanvasModule from "diagram-js/lib/navigation/movecanvas";
import ZoomScrollModule from "diagram-js/lib/navigation/zoomscroll";
import {getLinkageLogsListByActionId} from "@/network/device-linkage-activiti-logs";
import {getProInfo} from "@/network/activiti";

export default {
  name: "LinkageLogs",
  props: ["item"],
  data() {
    return {
      tableData: [],
      bpmnViewer: null,
      bpmnXmlStr: "",
      scale: 0,
      nodeIds: [],
      currentNode: [],
      isFullScreen: false,
    }
  },
  watch: {
    item() {
      this.getProInfo();
      this.getLinkageLogsListByActionId();
    },
  },
  mounted() {
    this.getProInfo();
    this.getLinkageLogsListByActionId();
    window.addEventListener('resize', () => {
      this.isFullScreen = !!(document.webkitIsFullScreen || document.mozFullScreen ||
        document.msFullscreenElement || document.fullscreenElement)
    }, false)
  },
  methods: {
    getProInfo() {
      getProInfo(this.item.id).then(res => {
        this.bpmnXmlStr = res.data.xml
        this.nodeIds = res.data.nodeInfoDto.hiNode
        this.currentNode = res.data.nodeInfoDto.currentNode
        this.initDiagram();
      })
    },
    initDiagram() {
      this.bpmnViewer && this.bpmnViewer.destroy();
      const canvas = this.$refs.canvas;
      this.scale = 0;
      // 生成实例
      this.bpmnViewer = new BpmnViewer({
        container: canvas,
        additionalModules: [
          // MoveModule, //可以调整元素,
          ZoomScrollModule, //鼠标滚动,
          ModelingModule, //基础工具 MoveModule,SetColor等依赖这个
          MoveCanvasModule //移动整个画布
        ]
        // height: 200,
      });
      // 新增流程定义
      this.createNewDiagram();
    },
    // 查询复杂策略动作详情
    getLinkageLogsListByActionId() {
      this.tableData = [];
      if (this.item && this.item.id) {
        getLinkageLogsListByActionId(this.item.id).then(res => {
          if (res.code === 0) {
            this.tableData = res.data;
          }
        });
      }
    },
    createNewDiagram: function () {
      // 将字符串转换成图显示出来
      this.bpmnViewer.importXML(this.bpmnXmlStr, err => {
        // eslint-disable-next-line no-empty
        if (err) {
          return console.error('could not import BPMN 2.0 diagram', err);
        } else {
          let canvas = this.bpmnViewer.get('canvas')
          canvas.zoom("fit-viewport", 'auto')
          //需要设置高亮颜色节点id集合
          this.setNodeColor(canvas, 'nodeSuccess')
        }
      });
    },
    setNodeColor(canvas, colorClass) {
      for (let i = 0; i < this.nodeIds.length; i++) {
        canvas.addMarker(this.nodeIds[i], colorClass)
      }
      for (let i = 0; i < this.currentNode.length; i++) {
        canvas.addMarker(this.currentNode[i], 'currentNode')
      }
    },
    handleZoom(flag) {
      if (flag < 0 && this.scale < 0) {
        return;
      }
      this.scale += flag;
      this.$nextTick(() => {
        this.bpmnViewer.get('canvas').zoom(this.scale)
      })
    },
    fullScreen() {
      if (this.isFullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      } else {
        let element = this.$refs.containers
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen()
        }
      }
    },
  },
}
</script>

<style lang="scss">
/*左边工具栏以及编辑节点的样式*/
@import "~bpmn-js/dist/assets/diagram-js.css";
@import "~bpmn-js/dist/assets/bpmn-font/css/bpmn.css";
@import "~bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css";
@import "~bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";

.containersView {
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: 100%;

  .canvas {
    width: 100%;
    height: 100%;
  }

  /*图形颜色*/
  //.djs-visual{
  //  > :nth-child(1){
  //    stroke: red !important;
  //  }
  //}
  /*字体颜色*/
  .djs-visual {
    .djs-label {
      stroke: none !important;
      fill: black;
    }
  }

  //.nodeSuccess:not(.djs-connection){
  .nodeSuccess {
    .djs-visual {
      > :nth-child(1) {
        stroke: rgb(38, 116, 170) !important;
        stroke-width: 3px !important;
      }

      path {
        fill: rgb(38, 116, 170) !important;
        stroke: rgb(38, 116, 170) !important;
      }
    }

    //.djs-hit.djs-hit-all{
    //  stroke: rgb(102, 170, 102) !important;
    //}
  }

  .currentNode {
    .djs-visual {
      > :nth-child(1) {
        stroke: rgb(102, 170, 102) !important;
        stroke-width: 3px !important;
      }

      path {
        fill: rgb(102, 170, 102) !important;
        stroke: rgb(102, 170, 102) !important;
      }
    }
  }

  .djs-connection.nodeSuccess {
    .djs-visual {
      path {
        fill: none !important;
      }
    }
  }

  .panel, .bjs-powered-by, .djs-palette.two-column.open {
    display: none;
  }

  .toolbar {
    position: absolute;
    top: 10px;
    right: 10px;

    a {
      text-decoration: none;
      margin: 5px;
      color: #409eff;
    }
  }
}
</style>

